<script setup lang="ts">
import ApplicationBase from '../ApplicationBase.vue'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'
import { useJoakimStore } from '@/stores/useJoakimStore'
import { watch } from 'vue'
import Umsaekjandi from '../Shared/Umsaekjandi.vue'
import Step2 from './Steps/Step2.vue'
import Step3 from './Steps/Step3.vue'
import Step4 from './Steps/Step4.vue'
import Step5 from './Steps/Step5.vue'
import Step6 from './Steps/Step6.vue'
import Step7 from './Steps/Step7.vue'
import Step8 from './Steps/Step8.vue'
import Step9 from './Steps/Step9.vue'
import Step10 from './Steps/Step10.vue'
import Step11 from './Steps/Step11.vue'
import Step12 from './Steps/Step12.vue'
import Step13 from './Steps/Step13.vue'
import Step14 from './Steps/Step14.vue'

import PEP from '../Shared/PEP.vue'
import Undirritun from '../Shared/Undirritun.vue'
import ApplicationOrorkaBegin from './Steps/ApplicationOrorkaBegin.vue'

const joakim = useJoakimStore()

async function runBankCheck(umsokn: any) {
  const res = await joakim.checkBankaReikning(umsokn)
  const data = (res as any)?.data ?? res
  const valid = !!data?.valid
  return { valid, errorMessage: valid ? '' : (data?.message || 'Ógildur bankareikningur') }
}

const steps = [
  { comp: ApplicationOrorkaBegin, titleKey: '' },
  { comp: Umsaekjandi,            titleKey: 'umsokn_umsaekjandi_header' },
  { comp: Step2,                  titleKey: 'umsokn_bankareikningur_header1', props: { runBankCheck } },
  { comp: Step3,                  titleKey: 'ororku_umsokn_step3_header_1' },
  { comp: Step4,                  titleKey: 'ororku_umsokn_step4_header' },
  { comp: Step5,                  titleKey: 'ororku_umsokn_step4_header' },
  { comp: Step6,                  titleKey: 'ororku_umsokn_step5_header' },
  { comp: Step7,                  titleKey: 'ororku_umsokn_step6_header' },
  { comp: Step8,                  titleKey: 'ororku_umsokn_step7_header' },
  { comp: Step9,                  titleKey: 'ororku_umsokn_step8_header' },
  { comp: Step10,                 titleKey: 'ororku_umsokn_step9_header' },
  { comp: Step11,                 titleKey: 'ororku_umsokn_step10_header' },
  { comp: Step12,                 titleKey: 'ororku_umsokn_step11_header' },
  { comp: Step13,                 titleKey: 'ororku_umsokn_step12_header' },
  { comp: PEP,                    titleKey: 'umsokn_PEP_header' },
  { comp: Step14,                 titleKey: 'ororku_umsokn_step13_header' },
  { comp: Undirritun,             titleKey: 'undirritun_umsokn_header1' }
]

const { umsokn, onLoaded } = useUmsokn()

// normalize collections once the application is loaded, if we send null the backend throws an error
onLoaded(() => {
  if (!umsokn.value) return

  if (!umsokn.value.childPension) umsokn.value.childPension = []
  if (!umsokn.value.anotherPensions) umsokn.value.anotherPensions = []
  if (!umsokn.value.healthDoctors) umsokn.value.healthDoctors = []
  if (!umsokn.value.healthorganizations) umsokn.value.healthorganizations = []
  if (!umsokn.value.career) umsokn.value.career = []
  
})


watch(
  () => umsokn.value,
  (newVal, oldVal) => {
    if (!umsokn.value) return

  if (!umsokn.value.childPension) umsokn.value.childPension = []
  if (!umsokn.value.anotherPensions) umsokn.value.anotherPensions = []
  if (!umsokn.value.healthDoctors) umsokn.value.healthDoctors = []
  if (!umsokn.value.healthorganizations) umsokn.value.healthorganizations = []
  if (!umsokn.value.career) umsokn.value.career = []
  },
  { deep: false }
)
</script>

<template>
  <ApplicationBase :app-id="3" update-key="ororkuumsokn" :steps="steps" />
</template>
